import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import TemplatePreview from '../../../../components/TemplatePreview';
import './templatepreview.css';

const applyTemplateParams = (text = '', params = []) => {
  if (!text) return '';

  return params.reduce((updatedText, value, index) => {
    const regex = new RegExp(`{{${index + 1}}}`, 'g');
    return updatedText.replace(regex, value ?? '');
  }, text);
};

const CampaignTemplatePreview = ({ visible, onClose, data }) => {
  const [previewData, setPreviewData] = useState(null);
  console.log('CampaignTemplatePreview data:', data);

  // Function to parse template payload safely
  function parseTemplatePayload(payload) {
    try {
      if (!payload || typeof payload !== 'object') {
        throw new Error('Invalid payload: must be an object');
      }

      const result = {
        language: payload?.language || null,
        category: payload?.category || null,
        status: payload?.status || null,
        id: payload?.id || null,
      };

      if (payload?.body || payload?.header || payload?.footer || payload?.buttons) {
        result.HEADER = payload?.header || '';
        result.BODY = applyTemplateParams(payload?.body || '', payload?.body_params || []);
        result.FOOTER = payload?.footer || '';
        result.BUTTONS = (payload?.buttons || []).map((btn) => ({
          type: btn?.type || '',
          text: btn?.text || '',
          url: btn?.url || '',
          phone_number: btn?.phone_number || '',
        }));
        return result;
      }

      const components = payload?.components ?? [];

      components.forEach((component) => {
        if (!component?.type) return;

        switch (component.type) {
          case 'HEADER':
            result.HEADER = component?.text ?? '';
            break;

          case 'BODY':
            result.BODY = applyTemplateParams(
              component?.text ?? '',
              component?.example?.body_text?.[0] ?? [],
            );
            break;

          case 'FOOTER':
            result.FOOTER = component?.text ?? '';
            break;

          case 'BUTTONS':
            result.BUTTONS = (component?.buttons ?? []).map((btn) => ({
              type: btn?.type ?? '',
              text: btn?.text ?? '',
            }));
            break;

          default:
            break;
        }
      });

      return result;
    } catch (error) {
      console.error('Error parsing template payload:', error.message);
      return null;
    }
  }

  useEffect(() => {
    if (data) {
      const parsed = parseTemplatePayload(data);
      setPreviewData(parsed);
    }
  }, [data]);

  return (
    <Dialog
      visible={visible}
      onHide={() => onClose(false)}
      closable={false}
      dismissableMask={true}
      className="w-96 p-0 m-0"
      position="right"
      modal
      draggable={false}
      resizable={false}
      contentClassName="p-0 m-0"
      style={{ borderRadius: '12px', overflow: 'hidden', padding: 0, margin: 0 }}
    >
      {/* Custom Header */}
      <div className="template-header">
        <h3>Template Preview</h3>
        <button onClick={() => onClose(false)}>&times;</button>
      </div>

      {/* Template Info */}
      <div className="template-card">
        <div className="template-info">
          <span className="label">Template</span>
          <span className="name">{data?.name}</span>
        </div>
        {data?.status && (
          <div
            className={
              data?.status === 'APPROVED' ? `status-badge-approved` : `status-badge-rejected`
            }
          >
            {data?.status}
          </div>
        )}
      </div>

      {/* Body Preview */}
      <div className="m-3">
        <TemplatePreview
          header={previewData?.HEADER || ''}
          footer={previewData?.FOOTER || ''}
          content={previewData?.BODY || ''}
          buttons={previewData?.BUTTONS || []}
        />
      </div>
    </Dialog>
  );
};

export default CampaignTemplatePreview;
